import Resource from '@/services/resources/common';

export default class PathResource extends Resource {
  constructor(entrypoint = '/paths', alias = 'Path') {
    super(entrypoint, alias);
  }
}
